<mat-card style="width: min-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>Service Requests</mat-card-title>
                <mat-card-subtitle>
                    Orders for labs, imaging, procedures, consultation, etc.
                </mat-card-subtitle>
            </div>

            <div class="right gap-10 g-just-flex" style="flex: 1 1 auto; justify-content: flex-end;">
                <!-- @if ((canAdd$ | async) && (auth.user | async)?.role === 'doctor' && -->
                @if ((canAdd$ | async) &&
                this.stateService.isEncounterActive() && this.stateService.currentEncounter.getValue()){
                <a mat-flat-button (click)="openAddDialog()">
                    <mat-icon>add</mat-icon>
                    Add Service Request
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>

        <div class="table-or-empty" style="background-color: transparent;">
            <!-- ALWAYS SHOW FILTERS - Even if no data -->
            <!-- @if(tableHeaderMappedFilterArray && tableHeaderMappedFilterArray.size > 0) {
            <mat-divider></mat-divider> -->
            <app-table-header [searchableFields]="searchableFields" [selectedSearchField]="selectedSearchField"
                (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
            </app-table-header>
            <!-- } -->

            <!-- TABLE OR EMPTY STATE -->
            @if(srSearch.dataSource.data && srSearch.dataSource.data.length > 0) {
            <!-- <mat-divider></mat-divider> -->

            <!-- <app-custom-tabs [tabs]="categoryTabs" [control]="categoryFiltering"></app-custom-tabs> -->

            <table style="min-width: 720px; width: unset" mat-table [dataSource]="srSearch.dataSource"
                class="mat-elevation-z8 demo-table">

                <ng-container matColumnDef="authoredOn">
                    <th mat-header-cell *matHeaderCellDef>Authored</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row.rawResource?.authoredOn || row.authoredOn) {
                        <div class="top pt-6">
                            {{ row.rawResource?.authoredOn || row.authoredOn | date:'mediumDate' }}
                        </div>
                        <div class="bottom pb-6 subtitle-text-color-2">
                            {{ row.rawResource?.authoredOn || row.authoredOn | date: 'mediumTime' }}
                        </div>
                        } @else {
                        N/A
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let row">
                        <div [appChips]="row.rawResource?.status || row.status" [fontSize]="'14px'"></div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>Category</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row.rawResource?.category && row.rawResource.category.length > 0) {
                        <span class="restrict-length">{{ row.rawResource?.category[0] | codeableConcept2 | na }}</span>
                        } @else {
                        <div>N/A</div>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let row" class="restrict-width">
                        <div class="g-just-flex gap-5 my-12" style="flex-direction: column; align-items: flex-start;">
                            <span class="restrict-length">{{ row.rawResource?.code | codeableConcept2 | na }}</span>
                            @if(row.available){
                            <div class="app-emphasis-badge"
                                [ngClass]="{'is-available': row.available === 'Available', 'is-unavailable': row.available !== 'Available'}">
                                {{row.available}}
                            </div>
                            }
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef>Subject</th>
                    <td mat-cell *matCellDef="let row">
                        <span [appReferenceDisplay]="row.rawResource?.subject?.reference || row.patientRef"
                            [instantFetchAndReplace]="true"></span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button
                            (click)="showRow(row.rawResource || row.actualResource || row); $event.stopPropagation()"
                            matTooltip="View">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" matHeaderRowDefSticky="true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    (click)="showRow(row.rawResource || row.actualResource || row)" style="cursor:pointer;"></tr>
            </table>

            <mat-paginator [length]="total$ | async" [pageSize]="pageSize" [pageIndex]="paginatorPageIndex"
                [pageSizeOptions]="[25, 50, 100]" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>

            } @else {
            <div class="g-just-flex flex-column align-items-center py-40"
                style="text-align:center; padding: 40px 20px;">
                <app-empty-state [icon]="'assignment'" [title]="'No Service Requests'"
                    [subtitle]="'No service requests found for the current context. Try adjusting your filters or search.'">
                </app-empty-state>
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>